import { render, staticRenderFns } from "./MXUploadCard.vue?vue&type=template&id=097ae102&scoped=true"
import script from "./MXUploadCard.vue?vue&type=script&lang=js"
export * from "./MXUploadCard.vue?vue&type=script&lang=js"
import "./MXUploadCard.vue?vue&type=style&index=0&id=097ae102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097ae102",
  null
  
)

export default component.exports